import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RuleInterface } from '@vendasta/automata';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import { NoRules } from '../../common';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { BrandingService } from '../../../../../data-services/whitelabel.service';

@Component({
  selector: 'automata-user-online-panel',
  templateUrl: './user-online-panel.component.html',
  styleUrls: ['./user-online-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
  ],
})
export class UserOnlinePanelComponent extends CommonTriggerPanelComponent implements OnInit {
  translationParams: Observable<Record<string, string>>;
  constructor(
    protected readonly translateService: TranslateService,
    private readonly brandingService: BrandingService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.savingEnabled$.next(true);
    this.translationParams = !this.automation.marketId
      ? of({ businessAppName: this.translateService.instant('COMMON.BUSINESS_APP') })
      : this.brandingService.getBusinessAppName(this.automation?.namespace, this.automation?.marketId).pipe(
          map((name) => {
            return { businessAppName: name };
          }),
        );
  }

  // Return true when your form is valid.
  isFormValid(): boolean {
    return true;
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return NoRules();
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    return rules;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }
}
